<template>
<div class="introduction">
    <div class="cont">
        年年岁岁花相似，岁岁年年人不同 。最是一年春好处，愿不负韶光，不负自己！快来约克论坛参与话题 #记录春天随手拍# 发帖，就有机会获得惊喜哦~ 
    </div>
</div>
</template>
<script>
export default {
    name:'SpringIntroduction2023'
}

</script>
<style lang="less" scoped>
.introduction{
    padding: 25px 50px; background: #fff; border-radius: 10px; position: relative;
    .cont{
        font-size: 18px; line-height: 30px;
    }

    &:before{
        content:''; display: block; position: absolute; left: 15px; top: 30px;
        background: url('./assets/down-quotes.png') no-repeat;
        width: 20px; height: 17px;
        transform: rotateZ(180deg);
    }
    &:after{
        content:''; display: block; position: absolute; right: 30px; bottom: 30px;
        background: url('./assets/down-quotes.png') no-repeat;
        width: 20px; height: 17px;
    }
}
@media screen and (max-width:768px){
    .introduction{
        padding: 15px 25px;
        .cont{
            font-size: 16px; line-height: 24px;
        }
        &:before{transform:rotateZ(180deg) scale(0.6); left: 3px; top: 18px;}
        &:after{transform: scale(0.6); right: 10px; bottom: 13px;}
    }
}
</style>